import React from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import ErrorBoundary from '../../ErrorBoundary';

const AdminUserEditViewModeSwitcher = ({
  profile,
  isSelfEdit,
  loggedInUser,
  viewModeSwitcher,
  handleSwitchViewModeSwitcher,
}) => {
  const intl = useIntl();

  if (
    isSelfEdit ||
    profile.role !== 'admin' ||
    !loggedInUser ||
    !loggedInUser.is_superadmin
  ) {
    return null;
  }

  return (
    <ErrorBoundary>
      <div className="user-role-view-mode-switcher">
        <Label for="switch-view-mode-switcher" className="switch">
          <Input
            type="checkbox"
            name="switch-view-mode-switcher"
            id="switch-view-mode-switcher"
            value="true"
            defaultChecked={viewModeSwitcher}
            onChange={handleSwitchViewModeSwitcher}
          />
          <i />
          <div className="switch-details">
            <span>
              {intl.formatMessage({ defaultMessage: 'Allow user to switch to global admin mode' })}
            </span>
          </div>
        </Label>
      </div>
    </ErrorBoundary>
  );
};

AdminUserEditViewModeSwitcher.propTypes = {
  profile: PropTypes.object.isRequired,
  isSelfEdit: PropTypes.bool.isRequired,
  loggedInUser: PropTypes.object,
  viewModeSwitcher: PropTypes.bool.isRequired,
  handleSwitchViewModeSwitcher: PropTypes.func.isRequired,
};

AdminUserEditViewModeSwitcher.defaultProps = {
  loggedInUser: null,
};

export default AdminUserEditViewModeSwitcher;
